var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"my-30"},[_c('Container',[_c('SectionHeader',[_vm._v("Documents")]),_c('div',{staticClass:"flex flex-wrap gap-10"},_vm._l((_vm.getDocuments),function(doc){return _c('a',{key:doc.url,staticClass:"flex gap-4 items-center border-2 py-2 px-4",class:{
            'border-[var(--bg-primary-color)]': !_vm.getPrimaryColor,
            [`border-[${_vm.getPrimaryColor}]`]: _vm.getPrimaryColor
          },attrs:{"href":doc.url,"target":"_blank"}},[_c('span',{staticClass:"text-base",class:{
              'text-[var(--bg-primary-color)]': !_vm.getPrimaryColor,
              [`text-[${_vm.getPrimaryColor}]`]: _vm.getPrimaryColor
            }},[_vm._v(_vm._s(doc.name))]),_c('FontAwesomeIcon',{class:{
              'text-primary-color': !_vm.getPrimaryColor,
              [`text-[${_vm.getPrimaryColor}]`]: _vm.getPrimaryColor
            },attrs:{"icon":"download","size":"sm"}})],1)}),0)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }